import React from 'react';

export function useEntitiesProjectIds<T extends { projectId?: string }>(entities: T[]): string[] {
  return React.useMemo(
    () => [
      ...entities.reduce((acc, entity) => {
        if (entity.projectId) {
          acc.add(entity.projectId);
        }

        return acc;
      }, new Set<string>()),
    ],
    [entities],
  );
}
